import React from "react";
import {
  Box,
  FormControl,
  FormLabel,
  MenuItem,
  Select,
  useTheme,
} from "@mui/material";
import type { SelectChangeEvent } from "@mui/material/Select";
import type { SxProps, Theme } from "@mui/material";
import {
  labelStyles,
  menuPaperStyles,
  selectStyles,
} from "../chat/message-feedback-modal/styles";

export type TeamStatisticsFocusFilterProps = {
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: string[];
  includeEmptyOption?: boolean;
  emptyOptionLabel?: string;
  disabled?: boolean;
  sx?: SxProps<Theme>;
};

export function TeamStatisticsFocusFilter({
  label,
  value,
  onChange,
  options,
  includeEmptyOption = true,
  emptyOptionLabel = "All",
  disabled = false,
  sx,
}: TeamStatisticsFocusFilterProps) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        minWidth: 220,
        maxWidth: 320,
        ...sx,
      }}
    >
      <FormLabel sx={labelStyles}>{label}</FormLabel>
      <FormControl fullWidth disabled={disabled} size="small">
        <Select
          size="small"
          value={value}
          onChange={(e: SelectChangeEvent<string>) =>
            onChange(String(e.target.value))
          }
          sx={selectStyles(theme)}
          displayEmpty={includeEmptyOption}
          MenuProps={{
            PaperProps: { sx: menuPaperStyles(theme) },
          }}
        >
          {includeEmptyOption ? (
            <MenuItem value="">{emptyOptionLabel}</MenuItem>
          ) : null}
          {options.map((opt) => (
            <MenuItem key={opt} value={opt}>
              {opt}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}
